// extracted by mini-css-extract-plugin
export default {"PartiesPage":"PartiesPage_PartiesPage__IBBtB"};